import { getProducers } from "@/api";

const state = {
  storeLoading: false,
  storeInfo: {},
  storeSelector: false,
  storeList: [],
  storeListTemp: [],
  route: "",
  drawer: false,
};
const getters = {
  storeInfo: state => state.storeInfo,
  storeSequencer: state => state.storeInfo.sequenciador,
  storeSlug: state => state.storeInfo.slug,
  storeName: state => state.storeInfo.nome_loja,
  storeSelector: state => state.storeSelector,
  storeList: state => state.storeList,
  storeListTemp: state => state.storeListTemp,
  storeLoading: state => state.storeLoading,
  storeSequencial: state =>
    state.storeInfo.sequenciador || state.storeInfo.loja,
  route: state => state.route,
  storeInfoIsEmpty: state => {
    return Object.keys(state.storeInfo).length === 0;
  },
  drawer: state => state.drawer,
};
const actions = {
  setStore({ commit, state, dispatch }, storeInfo) {
    switch (state.route) {
      case "events":
        dispatch(
          "fetchEvents",
          { producerId: storeInfo.sequenciador, filtro: [] },
          { root: true }
        );
        break;
      case "ticketPackage":
        dispatch(
          "fetchTicketPackages",
          { producerId: storeInfo.sequenciador, filtro: [] },
          { root: true }
        );
        break;
      case "salesByDay":
        dispatch(
          "fetchSalesByDay",
          { producerId: storeInfo.sequenciador },
          { root: true }
        );
        break;
      case "salesByEvent":
        dispatch(
          "fetchSalesByEvent",
          { producerId: storeInfo.sequenciador },
          { root: true }
        );
        break;
      case "salesByTicket":
        dispatch(
          "fetchSalesByTicket",
          { producerId: storeInfo.sequenciador },
          { root: true }
        );
        break;
      case "channelsSales":
        dispatch(
          "fetchSalesByChannel",
          { producerId: storeInfo.sequenciador },
          { root: true }
        );
        break;
      case "salesByPaymentMethod":
        dispatch(
          "fetchSalesByPaymentMethod",
          { producerId: storeInfo.sequenciador },
          { root: true }
        );
        break;
      case "salesByPointOfSale":
        dispatch(
          "fetchSalesByPointOfSale",
          { producerId: storeInfo.sequenciador },
          { root: true }
        );
        break;
      case "discountCouponReport":
        dispatch(
          "fetchDiscountCoupon",
          { producerId: storeInfo.sequenciador },
          { root: true }
        );
        break;
      case "packegeEmission":
        dispatch(
          "fetchSendingPackages",
          { producerId: storeInfo.sequenciador },
          { root: true }
        );
        break;
      case "generalAnalytical":
        dispatch(
          "fetchDetailedSalesByEvent",
          { producerId: storeInfo.sequenciador },
          { root: true }
        );
        break;
      case "consumerFiscalNote":
        dispatch(
          "fetchFinalConsumerNF",
          { producerId: storeInfo.sequenciador },
          { root: true }
        );
        break;
      case "cancellation":
        dispatch(
          "fetchCancellation",
          { producerId: storeInfo.sequenciador },
          { root: true }
        );
        break;
      default:
        break;
    }
    commit("setStore", storeInfo);
    commit("setStoreSelector", false);
  },
  setStoreSelector({ commit }) {
    commit("setStoreLoading", true);
    return getProducers().then(response => {
      commit("setStoreList", response.data);
      commit("setStoreListTemp", response.data);
      commit("setStoreLoading", false);
    });
  },
  setRoute({ commit }, route) {
    commit("setRoute", route);
  },
  updateCurrentStore({ dispatch, getters }) {
    dispatch("setStoreSelector").then(() => {
      dispatch(
        "setStore",
        getters.storeList.find(
          store => store.sequenciador === getters.storeSequencer
        )
      );
    });
  },
  clearStateApp({ commit }) {
    commit("setStore", {});
    commit("setStoreSelector", false);
    commit("setStoreList", []);
    commit("setStoreListTemp", []);
    commit("setStoreLoading", false);
    commit("setRoute", "");
  },
};
const mutations = {
  setStore(state, storeInfo) {
    state.storeInfo = storeInfo;
  },
  setStoreSelector(state, storeSelector) {
    state.storeSelector = storeSelector;
  },
  setStoreList(state, storeList) {
    state.storeList = storeList;
  },
  setStoreListTemp(state, storeListTemp) {
    state.storeListTemp = storeListTemp;
  },
  setStoreLoading(state, storeLoading) {
    state.storeLoading = storeLoading;
  },
  setRoute(state, route) {
    state.route = route;
  },
  toggleDrawer(state, drawer) {
    state.drawer = drawer;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
